// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-module_wrapper-nSEHj","content":"layout-module_content-lNwsP"};